interface Props {
  message: string;
  onDismiss: () => void;
}

export default function ErrorBanner({ message, onDismiss }: Props) {
  return (
    <div className="mt-4 flex items-start justify-between rounded-lg bg-rose-50 p-4 text-rose-900">
      <p className="text-sm">{message}</p>
      <button className="ml-3 text-xs font-medium text-rose-700 hover:text-rose-900" onClick={onDismiss} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
}
